import { useCallback } from "react";
import { EntityPreviewsLayout } from "../../shared/layouts/EntityPreviewsLayout";
import type { EntityScope } from "../../shared/scope";
import { AdminBondRequestPreviewsAll } from "./AdminBondRequestPreviewsAll";
import { AdminBondRequestPreviewsClosed } from "./AdminBondRequestPreviewsClosed";
import { AdminBondRequestPreviewsOpen } from "./AdminBondRequestPreviewsOpen";
import { BondRequestMetricsView } from "./request-metrics/BondRequestMetricsView";

export const AdminRequestsView = () => {
	const renderMetrics = useCallback(
		(scope: EntityScope) => <BondRequestMetricsView scope={scope} />,
		[],
	);

	return (
		<EntityPreviewsLayout
			title="Bond Requests"
			storageKey="admin_requests_view"
			enableScope
			renderMetrics={renderMetrics}
			tabs={[
				{
					id: "all",
					label: "All",
					Component: AdminBondRequestPreviewsAll,
				},
				{
					id: "open",
					label: "Open",
					isDefault: true,
					Component: AdminBondRequestPreviewsOpen,
				},
				{
					id: "closed",
					label: "Closed",
					Component: AdminBondRequestPreviewsClosed,
				},
			]}
		/>
	);
};
